







































































































import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import InputRencanaMpp from "@/components/mpp/PerencanaanMppInput.vue";
import ListPerencanaanMpp from "@/components/mpp/ListPerencanaanMpp.vue";
import PerencanaanMppModal from "@/components/mpp/PerencanaanMppModal.vue";
import { confirmRemove } from "@/utility/CommonHelper";
import mppModule from "@/store/modules/MppStore";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";

@Component({
  components: {
    InputRencanaMpp,
    ListPerencanaanMpp,
    PerencanaanMppModal
  }
})
export default class PerencanaanMppPage extends Vue {
  @Ref("refRencana") readonly refRencana!: any;
  @Prop() readonly register!: number;
  @Prop() readonly rm!: string;
  @Prop({ type: Boolean, default: false }) isReadonly!: boolean;

  dialog = false;
  selectedItem: any = null;
  saving = false;
  loading = false;
  showFullscreen = false;
  category = "rencana";

  get stateUser() {
    return userModule.user;
  }

  get riwayat() {
    return mppModule.getPerencanaan;
  }

  async loadRencanaData() {
    await mppModule.fetchAllMpp(this.register);
  }

  OpenModal() {
    this.$nextTick(() => {
      if (this.refRencana) {
        this.refRencana.resetForm();
      }
    });

    this.selectedItem = {
      id: null,
      unit_id: this.stateUser?.unit_id || null,
      user_id: this.stateUser?.id || null,
      unit: { id: this.stateUser?.unit_id, nama: this.stateUser?.unit },
      user: { id: this.stateUser?.id, nama: this.stateUser?.nama },
      authored_at: new Date(),
      category: this.category,
      content: []
    };

    this.dialog = true;
  }

  CloseModal() {
    this.dialog = false;

    setTimeout(() => {
      this.selectedItem = null;
      if (this.refRencana) {
        this.refRencana.resetForm();
      }
    }, 300);
  }

  Edit(item: any) {
    this.selectedItem = JSON.parse(JSON.stringify(item));

    if (
      this.selectedItem.authored_at &&
      typeof this.selectedItem.authored_at === "string"
    ) {
      this.selectedItem.authored_at = new Date(this.selectedItem.authored_at);
    }

    this.dialog = true;
  }

  async Save() {
    if (this.saving) return;

    if (this.refRencana && !this.refRencana.validasi()) {
      appModule.sendErrorAlert("Mohon lengkapi Tanggal & Jam Pencatatan.");
      return;
    }

    // Ambil data terakhir dari komponen input
    const dataRencana = this.refRencana.sendData;
    // content baru berbentuk objek { nama_perawat, rencana: [...] };
    // tetap dukung bentuk lama (array) untuk keamanan.
    const content = dataRencana.content;
    const rencana = Array.isArray(content) ? content : content?.rencana || [];

    const hasAnyRencana = rencana.some(
      (a: any) =>
        (a.asesmen && a.asesmen.length > 0) || (a.plan && a.plan.length > 0)
    );

    if (!hasAnyRencana) {
      appModule.sendErrorAlert(
        "Wajib pilih minimal satu Asesmen dan Intervensi."
      );
      return;
    }

    const incompleteAspek: string[] = [];
    rencana.forEach((a: any) => {
      const hasAses = a.asesmen && a.asesmen.length > 0;
      const hasPlan = a.plan && a.plan.length > 0;
      if ((hasAses && !hasPlan) || (!hasAses && hasPlan)) {
        // Gunakan nama_aspek jika kategori tidak ada
        incompleteAspek.push(a.nama_aspek || a.kategori || "aspek ini");
      }
    });

    if (incompleteAspek.length > 0) {
      appModule.sendErrorAlert(
        "Data Asesmen & Rencana Intervensi belum lengkap untuk " +
          incompleteAspek.join(", ") +
          ". Harap pilih minimal satu keduanya."
      );
      return;
    }
    // ---------------------------------------

    this.saving = true;

    try {
      await mppModule.saveMpp({
        category: this.category,
        data: dataRencana,
        isEdit: !!this.selectedItem?.id
      });
      appModule.sendSuccessNotice("Data perencanaan berhasil disimpan");
      this.CloseModal();
      //await this.loadRencanaData(); // Reload list agar sinkron
    } catch (error) {
      console.error("Error saving perencanaan:", error);
    } finally {
      this.saving = false;
    }
  }

  async Delete(item: any) {
    const confirmed = await confirmRemove(
      "Hapus Perencanaan",
      "Apakah Anda yakin ingin menghapus data perencanaan ini?"
    );

    if (confirmed) {
      try {
        await mppModule.deleteMpp({
          category: this.category,
          id: item.id
        });
        appModule.sendSuccessNotice("Data berhasil dihapus");
        //await this.loadRencanaData(); // Reload data
      } catch (error) {
        console.error("Gagal menghapus data:", error);
      }
    }
  }
}
